import { render, staticRenderFns } from "./QuickviewCompetitor.vue?vue&type=template&id=565ccb4f&scoped=true&"
import script from "./QuickviewCompetitor.vue?vue&type=script&lang=js&"
export * from "./QuickviewCompetitor.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewCompetitor.vue?vue&type=style&index=0&id=565ccb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ccb4f",
  null
  
)

export default component.exports